import React from 'react';
import { ColumnComponentProps } from 'v2/utils/searchViewUtils';
import { REVIEW_STATUS } from 'v2/utils/searchUtils';

const SearchType = ({ search }: ColumnComponentProps) => {
  return (
    <p className="d-flex align-items-center">
      {search.review_status === REVIEW_STATUS.APPROVED
        ? 'External'
        : 'Internal'}
    </p>
  );
};

export default SearchType;
